import { exceptionTypes } from 'shared/helpers/constants/companies/exceptionTypes';
import { isFactoryReversed } from 'shared/helpers/matchers/matcherFactory';

const isHedgeNotRequired = isFactoryReversed(exceptionTypes.hedge_not_required);
const isHedgeRequired = isFactoryReversed(exceptionTypes.hedge_required);

export { isHedgeNotRequired, isHedgeRequired };
